import { jsx as _jsx } from "react/jsx-runtime";
import { WithGoogleAuth } from "./with-google-auth";
import { WithQuery } from "./with-query";
import { WithWagmi } from "./with-wagmi";
export var Providers = function (_a) {
    var children = _a.children;
    return (_jsx(WithWagmi, { children: _jsx(WithQuery, { children: _jsx(WithGoogleAuth, { children: children }) }) }));
};
